import styled, { css } from 'styled-components/macro'

import { Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

function getDeadlineDateStyle($hasValidDeadline: boolean) {
  return (
    $hasValidDeadline &&
    css`
      color: ${getToken('color-primary')};
      font-weight: ${getToken('font-weight-bold')};
    `
  )
}

export const StyledDeadlineDate = styled(Text)<{ $hasValidDeadline: boolean }>`
  ${({ $hasValidDeadline }) => getDeadlineDateStyle($hasValidDeadline)};
`
